<template>
  <md-autocomplete
    v-model="selectedCountry"
    :md-options="countryOptions"
    :md-fuzzy-search="false"
    @md-selected="emitUpdate"
  >
    <label>{{ label }}</label>

    <template
      slot="md-autocomplete-item"
      slot-scope="{ item, term }"
    >
      <md-highlight-text :md-term="term">
        {{ item }}
      </md-highlight-text>
    </template>
  </md-autocomplete>
</template>
<script>
    import {countryOptions, countryNameToCode, countryCodeToName} from "@/assets/countries_iso/all-iso-codes";

    export default {
        props: {
            label: {
                type: String,
                default: "Choose country"
            },
            country: {
                type: String,
                default: ""
            },
        },
        data() {
            return {
                countryOptions,
                selectedCountry: this.$props.country,
            };
        },
        watch: {
            country() {
                if (this.selectedCountry !== countryCodeToName[this.$props.country]) {
                    this.selectedCountry = countryCodeToName[this.$props.country];
                }
            },
        },
        methods: {
            emitUpdate() {
                this.$emit("countrySelected", countryNameToCode[this.selectedCountry] || "invalid");
            },
        },
    };
</script>
<style>
    .md-menu-content-bottom-start {
        width: 350px !important;
        max-width: 350px !important;
    }
</style>
